import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../commonComponents/translate';
import CourseProp from '../academy/propTypes/courseProp';
import Anchor from '../../commonComponents/Anchor';
import MetaContext from '../../contextProviders/MetaContext';

function Highlight({ t, course, compactDisplay }) {
  const { meta } = useContext(MetaContext);
  const { url } = meta || {};

  const image = course.image || course.imageSquare;
  const imageUrl = image ? image.url : '/images/no_image_upload.png';
  const containerClass = cx('highlighted-course', { compact: compactDisplay });

  return (
    <div
      className={containerClass}
      itemScope
      itemType="http://schema.org/Course"
    >
      <div itemProp="courseCode" content={course._id}>
        <Anchor
          itemProp="url"
          content={`/academy/${course.slug}`}
          href={`/academy/${course.slug}/play`}
          className="highlighted-course-image course-play-button"
        >
          <img
            alt="highlighted course"
            src={imageUrl}
            itemProp="image"
            content={imageUrl}
          />
        </Anchor>
        <div
          className="highlighted-course-info"
          itemProp="description"
          content={course.description}
        >
          <div
            className="highlighted-course-text"
            itemProp="provider"
            content={`${url}#organization`}
          >
            <Anchor
              href={`/academy/${course.slug}`}
              className="highlighted-course-title"
              itemProp="url"
            >
              <div itemProp="name">{course.name}</div>
            </Anchor>
            <span className="highlighted-course-modules">
              <i className="la la-list" />
              <span
                className="highlighted-course-modules-value"
                itemProp="numberOfCredits"
              >
                {course.modules}
              </span>
              <span className="highlighted-course-modules-title">
                {t('academy_modules')}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

Highlight.propTypes = {
  t: PropTypes.func.isRequired,
  course: PropTypes.shape(CourseProp.propType).isRequired,
  compactDisplay: PropTypes.bool,
};

Highlight.defaultProps = {
  compactDisplay: false,
};

export default translate(Highlight);
